import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import FAQAccordion from "@/components/FAQAccordion";

const FaqPage = () => {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true }) || [];
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };
  return (
    <>
      <Seo titleKey="seo.faq_title" descKey="seo.faq_desc" path="/faq" schema={schema} />
      <section className="container-x pt-14 pb-4">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">{t("nav.faq")}</p>
        <h1 className="mt-2 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-slate-900">
          {t("faq.title")}
        </h1>
      </section>
      <FAQAccordion />

      <section className="container-x max-w-3xl pb-20">
        <div className="rounded-3xl bg-gradient-to-br from-brand-green to-emerald-700 p-8 sm:p-10 text-white text-center">
          <h2 className="font-heading font-extrabold text-2xl sm:text-3xl">{t("faq.cta_title")}</h2>
          <p className="mt-2 text-emerald-100 text-sm sm:text-base">{t("faq.cta_subtitle")}</p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/devis" className="inline-flex items-center justify-center gap-2 bg-white text-brand-green font-semibold rounded-full px-6 py-3 hover:bg-emerald-50 transition">
              {t("common.cta_quote")} <ArrowRight className="h-4 w-4" />
            </Link>
            <a href="tel:+33649502801" className="inline-flex items-center justify-center gap-2 border border-white/40 text-white font-semibold rounded-full px-6 py-3 hover:bg-white/10 transition">
              {t("common.cta_call")}
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqPage;
